/**
 * Probe wordmark — letters-only logo.
 *
 * Variants:
 *   "dark"  — black letters on light surfaces (nav bar)
 *   "light" — white letters on the brand-blue hero
 *   "blue"  — brand-blue letters on light surfaces
 *
 * Sizes: "sm" 18px • "md" 22px • "lg" 32px • "xl" 56px
 */

const SIZE_MAP = {
  sm: "text-[20px]",
  md: "text-[28px]",
  lg: "text-[40px]",
  xl: "text-[64px]",
};

const VARIANT_MAP = {
  dark: "text-black",
  light: "text-white",
  blue: "text-[#000000]",
};

export const ProbeLogo = ({ size = "md", variant = "dark", className = "" }) => {
  const sizeCls = SIZE_MAP[size] || SIZE_MAP.md;
  const variantCls = VARIANT_MAP[variant] || VARIANT_MAP.dark;
  return (
    <span
      data-testid="probe-logo"
      aria-label="Probe"
      className={`font-['Geist'] font-semibold leading-none select-none ${sizeCls} ${variantCls} ${className}`}
      style={{ letterSpacing: "-0.045em" }}
    >
      Probe
    </span>
  );
};

export default ProbeLogo;
